<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          회원
          <el-button class="title_btn" @click="$router.push('/member/create')">회원 추가</el-button>
        </div>
        <div>
          <member-list-component :memberType="`member`"></member-list-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberListComponent from "@/components/member/MemberListComponent";

export default {
  name: "Member",
  mixins: [],
  components: {
    MemberListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>